"use client";

import { c as _c } from "react/compiler-runtime";
import { useFilter } from "@/components/filters/filter-context";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { cn } from "@/lib/utils";
import { format } from "date-fns";
import { CalendarIcon } from "lucide-react";
import type { HTMLAttributes } from "react";
import { useCallback, useMemo } from "react";
import type { DateRange } from "react-day-picker";
import { es } from "react-day-picker/locale";
interface DateRangeFilterProps extends HTMLAttributes<HTMLDivElement> {
  readonly id: string;
  readonly defaultFrom?: Date;
  readonly defaultTo?: Date;
  readonly placeholder?: string;
}
export function DateRangeFilter(t0) {
  const $ = _c(40);
  const {
    className,
    id,
    defaultFrom,
    defaultTo,
    placeholder: t1
  } = t0;
  const placeholder = t1 === undefined ? "Selecciona una fecha" : t1;
  const {
    getFilterValues,
    setFilterValues,
    registerDefaultValue
  } = useFilter();
  const fromId = `${id}_from`;
  const toId = `${id}_to`;
  registerDefaultValue(fromId, defaultFrom ? [defaultFrom.toISOString()] : []);
  registerDefaultValue(toId, defaultTo ? [defaultTo.toISOString()] : []);
  let t2;
  if ($[0] !== fromId || $[1] !== getFilterValues) {
    t2 = getFilterValues(fromId);
    $[0] = fromId;
    $[1] = getFilterValues;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const fromValues = t2;
  let t3;
  if ($[3] !== getFilterValues || $[4] !== toId) {
    t3 = getFilterValues(toId);
    $[3] = getFilterValues;
    $[4] = toId;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const toValues = t3;
  let t4;
  bb0: {
    if (fromValues.length === 1 && fromValues[0] === "" || toValues.length === 1 && toValues[0] === "") {
      t4 = undefined;
      break bb0;
    }
    let t5;
    if ($[6] !== fromValues[0] || $[7] !== fromValues.length) {
      t5 = fromValues.length > 0 && fromValues[0] ? new Date(fromValues[0]) : undefined;
      $[6] = fromValues[0];
      $[7] = fromValues.length;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    let t6;
    if ($[9] !== toValues[0] || $[10] !== toValues.length) {
      t6 = toValues.length > 0 && toValues[0] ? new Date(toValues[0]) : undefined;
      $[9] = toValues[0];
      $[10] = toValues.length;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    let t7;
    if ($[12] !== t5 || $[13] !== t6) {
      t7 = {
        from: t5,
        to: t6
      };
      $[12] = t5;
      $[13] = t6;
      $[14] = t7;
    } else {
      t7 = $[14];
    }
    t4 = t7;
  }
  const date = t4;
  let t5;
  if ($[15] !== fromId || $[16] !== setFilterValues || $[17] !== toId) {
    t5 = selectedDate => {
      setFilterValues(fromId, selectedDate?.from ? [selectedDate.from.toISOString()] : []);
      setFilterValues(toId, selectedDate?.to ? [selectedDate.to.toISOString()] : []);
    };
    $[15] = fromId;
    $[16] = setFilterValues;
    $[17] = toId;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  const handleSelect = t5;
  let t6;
  if ($[19] !== className) {
    t6 = cn("grid gap-2", className);
    $[19] = className;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  const t7 = !date?.from && !date?.to && "text-muted-foreground";
  let t8;
  if ($[21] !== t7) {
    t8 = cn("justify-start text-left font-medium", t7);
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== date || $[24] !== placeholder) {
    t9 = <span className="flex-1">{date?.from ? date.to ? <>Del {format(date.from, "dd/MM/y")} al{" "}{format(date.to, "dd/MM/y")}</> : <>A partir del {format(date.from, "dd/MM/y")}</> : <span className="text-muted-foreground">{placeholder}</span>}</span>;
    $[23] = date;
    $[24] = placeholder;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <CalendarIcon />;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== t8 || $[28] !== t9) {
    t11 = <PopoverTrigger asChild={true}><Button className={t8} id="date" variant="outline">{t9}{t10}</Button></PopoverTrigger>;
    $[27] = t8;
    $[28] = t9;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] !== date || $[31] !== defaultFrom || $[32] !== handleSelect) {
    t12 = <PopoverContent align="start" className="w-auto p-0"><Calendar defaultMonth={defaultFrom} mode="range" numberOfMonths={1} min={1} locale={es} onSelect={handleSelect} selected={date} /></PopoverContent>;
    $[30] = date;
    $[31] = defaultFrom;
    $[32] = handleSelect;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  let t13;
  if ($[34] !== t11 || $[35] !== t12) {
    t13 = <Popover>{t11}{t12}</Popover>;
    $[34] = t11;
    $[35] = t12;
    $[36] = t13;
  } else {
    t13 = $[36];
  }
  let t14;
  if ($[37] !== t13 || $[38] !== t6) {
    t14 = <div className={t6}>{t13}</div>;
    $[37] = t13;
    $[38] = t6;
    $[39] = t14;
  } else {
    t14 = $[39];
  }
  return t14;
}